import Link from 'atomic/link';
import React from 'react';
import Container from 'atomic/container';
import WidgetSectionProps from './widget-section.props';
import Icon from 'atomic/icon';
import classNames from 'classnames';

import './widget-section.scss';

const WidgetSection: React.FC<WidgetSectionProps> = (
    {
        className,
        title,
        link,
        badge,
        styles,
        children
    }
) => (
    <div
        className={classNames({
            'widget-section': true,
            'widget-section--none-bg': !styles?.background?.url,
            [`${className}`]: !!className
        })}
        style={{
            backgroundColor: styles?.background?.color ?? void 0,
            backgroundImage: styles?.background?.url ? `url(${styles?.background?.url})` : void 0,
            backgroundPosition: styles?.background?.position || 'center'
        }}
    >
        <Container>
            {(title?.text && title?.text.trim().length > 0) && (
                <div className="widget-section__header">
                    <h2 className="widget-section__header__title" style={{ color: title?.styles?.color }}>
                        {title?.text}
                        {badge?.text && (
                            <span
                                className="widget-section__header__title__badge"
                                style={{
                                    color: badge?.styles?.color || '#fff',
                                    backgroundColor: badge?.styles?.background || '#0f5faf'
                                }}
                            >
                                {badge?.text}
                            </span>
                        )}
                    </h2>

                    {link?.url && (
                        <Link
                            color={link?.styles?.color ?? 'secondary'}
                            href={link.url}
                            className="widget-section__header__link"
                        >
                            {link?.text || ' Sprawdź pozostałe'}
                            <Icon name="arrow-right" color="primary" size={20}/>
                        </Link>
                    )}
                </div>
            )}
            {children}
        </Container>
    </div>
);

export default WidgetSection;
